<template>
  <div class="yl-chat-page">
    <!-- 错误页面：客服不存在 -->
    <div v-if="agentNotFound" class="yl-error-container">
      <div class="yl-error-icon">⚠️</div>
      <div class="yl-error-title">链接无效</div>
      <div class="yl-error-message">该客服账号不存在或链接已失效</div>
    </div>

    <!-- 加载中 -->
    <div v-else-if="isVerifying" class="yl-loading-container">
      <div class="yl-loading-spinner"></div>
      <div class="yl-loading-text">正在连接客服...</div>
    </div>

    <!-- 正常聊天界面 -->
    <div v-else class="yl-chat-container">
      <!-- 顶部导航 -->
      <div class="Nai-4lg2vHR7o-Long">
        <div class="Nai-jyPOXfXH1-Long">
          <div class="">
            <img class="Nai-jyPOXfXH1-Long" src="@/assets/pz/icon-back-v2.png">
          </div>
        </div>
        <img class="Nai-EzD-TlcDL-Long" src="@/assets/NaiLong-DFiibrak-NaiLong.png" alt="">
      </div>

      <!-- 聊天消息区域 -->
      <div class="yl-messages" ref="messagesContainer">
        <div v-for="msg in chatMessages" :key="msg.id" :class="['yl-message', msg.speakerType === 1 ? 'yl-message-right' : 'yl-message-left']">
          <!-- 客服消息 (左边) -->
          <template v-if="msg.speakerType !== 1">
            <div class="Nai-LgT6OkF7v-Long" style="--avatarSize: 40px; --avatarBorderRadius: 0;">
              <img src="@/assets/NaiLong-B2rxMlga-NaiLong.png">
            </div>
            <div class="yl-bubble yl-bubble-agent" v-if="!isPaymentCard(msg.content) && !isLinkCardMessage(msg.content)">
              <img v-if="isImageMessage(msg.content)" :src="getImageUrl(msg.content)" class="yl-msg-image" referrerpolicy="no-referrer" @click="previewImage(msg.content)">
              <span v-else>{{ msg.content }}</span>
            </div>
            <!-- 链接卡片 -->
            <div class="link-card-msg" v-else-if="isLinkCardMessage(msg.content)">
              <div class="link-card-inner">
                <h4 class="link-card-title">{{ parseLinkCardMessage(msg.content)?.title }}</h4>
                <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(msg.content)?.link)">{{ parseLinkCardMessage(msg.content)?.btnText || '查看详情' }}</div>
              </div>
            </div>
            <div class="payment-card" v-else>
              <div class="payment-card-header"><div>安全支付</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
              <div class="payment-card-order">订单编号：{{ getPaymentOrderId(msg.content) }}</div>
              <div class="payment-card-btn" @click="openPaymentPage(msg.content)">前往支付</div>
            </div>
          </template>
          <!-- 客户消息 (右边) -->
          <template v-else>
            <div class="Nai-LgT6OkF7v-Long" style="--avatarSize: 40px; --avatarBorderRadius: 0;">
              <img src="@/assets/NaiLong-_bRQCdww-NaiLong.png">
            </div>
            <div class="yl-bubble yl-bubble-customer" v-if="!isPaymentCard(msg.content) && !isLinkCardMessage(msg.content)">
              <img v-if="isImageMessage(msg.content)" :src="getImageUrl(msg.content)" class="yl-msg-image" referrerpolicy="no-referrer" @click="previewImage(msg.content)">
              <span v-else>{{ msg.content }}</span>
            </div>
            <!-- 链接卡片 -->
            <div class="link-card-msg" v-else-if="isLinkCardMessage(msg.content)">
              <div class="link-card-inner">
                <h4 class="link-card-title">{{ parseLinkCardMessage(msg.content)?.title }}</h4>
                <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(msg.content)?.link)">{{ parseLinkCardMessage(msg.content)?.btnText || '查看详情' }}</div>
              </div>
            </div>
            <div class="payment-card" v-else>
              <div class="payment-card-header"><div>安全支付</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
              <div class="payment-card-order">订单编号：{{ getPaymentOrderId(msg.content) }}</div>
              <div class="payment-card-btn" @click="openPaymentPage(msg.content)">前往支付</div>
            </div>
          </template>
        </div>
      </div>

      <!-- 输入区域 -->
      <div class="yl-input-area">
        <div class="yl-input-row">
          <div class="yl-input-wrapper">
            <input 
              v-model="inputContent" 
              class="yl-input" 
              placeholder="请输入消息内容"
              @keypress.enter="sendMessage"
            >
          </div>
          <!-- 加号按钮（无文字时显示） -->
          <button v-if="!inputContent.trim()" class="yl-add-btn" @click="toggleToolbar">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="11" stroke="#999" stroke-width="1.5"/>
              <path d="M12 7V17M7 12H17" stroke="#999" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <!-- 发送按钮（有文字时显示） -->
          <button v-else class="yl-send-btn" @click="sendMessage">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </button>
        </div>
        <!-- 工具栏面板 -->
        <div v-show="showToolbar" class="yl-toolbar">
          <div class="yl-toolbar-item" @click="triggerImageUpload">
            <div class="yl-toolbar-icon">
              <svg width="28" height="28" viewBox="0 0 48 48" fill="#666">
                <path d="M37 6.5a7.5 7.5 0 0 1 7.5 7.5v21a7.5 7.5 0 0 1-7.5 7.5H11A7.5 7.5 0 0 1 3.5 35V14A7.5 7.5 0 0 1 11 6.5Zm0 3H11A4.5 4.5 0 0 0 6.5 14v21a4.5 4.5 0 0 0 4.5 4.5h26a4.5 4.5 0 0 0 4.5-4.5V14A4.5 4.5 0 0 0 37 9.5ZM14.5 13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm24.993 6.858a1.5 1.5 0 0 1-1.351 1.635c-2.463.234-4.205.896-5.268 1.928-.249.241-.46.526-.696.946l-.183.34-.198.4-.258.55-.252.523-.25.483c-1.083 2.009-2.188 2.909-4.358 3.05-1.272.084-2.44-.05-4.01-.396l-1.97-.464-.614-.137-.284-.06-.528-.1c-1.007-.179-1.747-.218-2.6-.15-1.896.152-3.693 1.547-5.387 4.367a1.5 1.5 0 1 1-2.572-1.546c2.148-3.574 4.72-5.571 7.719-5.811 1.393-.112 2.497-.012 4.176.344l.704.156 1.633.388c1.516.352 2.515.483 3.536.416.944-.062 1.377-.41 2.039-1.713l.196-.4.257-.549c.62-1.322 1.072-2.072 1.81-2.79 1.615-1.567 3.987-2.468 7.074-2.761a1.5 1.5 0 0 1 1.635 1.351Z"/>
              </svg>
            </div>
            <span class="yl-toolbar-text">图片</span>
          </div>
        </div>
        <input type="file" ref="imageInput" accept="image/*" style="display:none" @change="handleImageUpload">
      </div>
    </div>
    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" :class="{ active: imagePreviewVisible }" @click.self="closeImagePreview">
      <img class="image-preview-content" :src="previewImageUrl" alt="预览图片">
    </div>
  </div>
</template>

<script>
import { apiFetch, API_BASE_URL } from '@/config/api'
import { chatWebSocket } from '@/utils/websocket'
export default {
  name: 'YlChat',
  props: {
    agentId: { type: String, default: '' }
  },
  data() {
    return {
      inputContent: '',
      chatMessages: [],
      lastMessageId: 0,
      customerName: '',
      agentAccount: '',
      sessionId: '',
      pollingInterval: null,
      pollingTimer: null,
      statusPollingInterval: null,
      wsUnsubscribe: null,
      isVerifying: true,
      agentNotFound: false,
      showToolbar: false,
      imagePreviewVisible: false,
      previewImageUrl: '',
    }
  },
  mounted() {
    this.initSession()
    // 按接口计数访问（sessionStorage去重，同一会话只计一次）
    const _up = new URLSearchParams(window.location.search)
    const _arid = _up.get('arid'), _artype = _up.get('artype')
    if (_arid && _artype) {
      const _dedupKey = `_tv_${_artype}_${_arid}`
      if (!sessionStorage.getItem(_dedupKey)) {
        sessionStorage.setItem(_dedupKey, '1')
        fetch(`${API_BASE_URL}/api/chat/track-visit?linkId=${_arid}&linkType=${_artype}`, { method: 'POST' }).catch(() => {})
      }
    }
    // 注册访客
    const _self = this
    setTimeout(() => {
      if (_self.agentAccount && _self.customerName) {
        fetch(`${API_BASE_URL}/api/chat/register-visit`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({sessionKey: `${_self.customerName}_${_self.agentAccount}`, agent: _self.agentAccount, customerName: _self.customerName, platform: 'yl'}) }).catch(() => {})
      }
    }, 2000)
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeUnmount() {
    this.stopPolling()
    this.disconnectWebSocket()
    this.setCustomerOffline()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    getAgentAccount() {
      if (this.agentId) return this.agentId
      const urlParams = new URLSearchParams(window.location.search)
      const agentParam = urlParams.get('custuuid') || urlParams.get('agent') || urlParams.get('id')
      if (agentParam) return agentParam
      const pathMatch = window.location.pathname.match(/\/yl-chat\/([^/]+)/)
      if (pathMatch) return pathMatch[1]
      return 'admin'
    },
    generateCustomerName() {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let result = 'yl_'
      for (let i = 0; i < 8; i++) result += chars.charAt(Math.floor(Math.random() * chars.length))
      return result
    },
    getOrCreateCustomerName() {
      const agentId = this.getAgentAccount()
      const storageKey = `yl_customer_name_${agentId}`
      let name = localStorage.getItem(storageKey)
      if (!name || !name.startsWith('yl_')) {
        name = this.generateCustomerName()
        localStorage.setItem(storageKey, name)
      }
      return name
    },
    async verifyAgent() {
      this.isVerifying = true
      let verified = false
      while (!verified) {
        try {
          const res = await apiFetch(`/api/chat/verify-agent?agentAccount=${encodeURIComponent(this.agentAccount)}`)
          this.agentNotFound = !(res.code === 0 && res.data?.exists)
          if (res.code === 0 && res.data?.agentAccount) this.agentAccount = res.data.agentAccount
          verified = true
          this.isVerifying = false
          return !this.agentNotFound
        } catch (e) {
          console.error('验证客服账号失败，2秒后重试...', e)
          await new Promise(resolve => setTimeout(resolve, 2000))
        }
      }
    },
    async initSession() {
      this.agentAccount = this.getAgentAccount()
      this.customerName = this.getOrCreateCustomerName()
      this.sessionId = `${this.customerName}_${this.agentAccount}`
      console.log('银联客服初始化:', this.sessionId)
      if (!(await this.verifyAgent())) return
      await this.loadInitialMessages()
      this.connectWebSocket()
      this.startPolling()
      this.updateOnlineStatus()
    },
    async loadInitialMessages() {
      try {
        // 客户端查看消息，viewerType=customer
        const res = await apiFetch(`/api/chat/messages?sessionId=${encodeURIComponent(this.sessionId)}&viewerType=customer`)
        if (res.code === 0 && res.data?.length > 0) {
          this.chatMessages = res.data
          this.lastMessageId = Math.max(...res.data.map(m => m.id))
          this.scrollToBottom()
          // 上报客户已读位置
          this.updateReadPosition(this.lastMessageId)
        }
      } catch (e) { console.error(e) }
    },
    // 上报已读位置（新的已读逻辑）
    async updateReadPosition(lastReadMessageId) {
      if (!lastReadMessageId) return
      try {
        await apiFetch('/api/chat/read-position', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.sessionId,
            userType: 'customer',
            lastReadMessageId: lastReadMessageId
          })
        })
      } catch (e) { console.log('更新已读位置失败:', e) }
    },
    async checkNewMessages() {
      try {
        const res = await apiFetch(`/api/chat/poll?sessionId=${encodeURIComponent(this.sessionId)}&lastId=${this.lastMessageId}`)
        if (res.code === 0 && res.data?.length > 0) {
          const ids = new Set(this.chatMessages.map(m => m.id))
          const newMsgs = res.data.filter(m => !ids.has(m.id))
          if (newMsgs.length > 0) {
            this.chatMessages.push(...newMsgs)
            this.lastMessageId = Math.max(...res.data.map(m => m.id))
            this.scrollToBottom()
            // 如果有客服消息，播放提示音并上报已读位置
            if (newMsgs.some(m => m.speakerType === 2)) {
              this.playSound()
              this.updateReadPosition(this.lastMessageId)
            }
          }
        }
      } catch (e) { console.log(e) }
      // 每次轮询时更新在线状态
      this.updateOnlineStatus()
    },
    startPolling() {
      // 消息轮询（自适应间隔：WebSocket连接时15s，断开时3s）
      const scheduleMessagePoll = () => {
        const delay = chatWebSocket.isConnected() ? 15000 : 3000
        this.pollingTimer = setTimeout(() => {
          this.checkNewMessages().then(() => {
            if (this.pollingTimer !== null) scheduleMessagePoll()
          })
        }, delay)
      }
      scheduleMessagePoll()
      // 心跳轮询（每4秒）
      this.statusPollingInterval = setInterval(() => this.sendHeartbeat(), 4000)
      // 已读位置上报（每30秒）
      this.readPositionInterval = setInterval(() => {
        if (this.lastMessageId && document.visibilityState === 'visible') this.updateReadPosition(this.lastMessageId)
      }, 30000)
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer)
        this.pollingTimer = null
      }
      if (this.statusPollingInterval) clearInterval(this.statusPollingInterval)
      if (this.readPositionInterval) clearInterval(this.readPositionInterval)
    },
    // WebSocket 连接
    async connectWebSocket() {
      try {
        await chatWebSocket.connect(this.sessionId)
        this.wsUnsubscribe = chatWebSocket.onMessage((data) => {
          this.handleWebSocketMessage(data)
        })
        console.log('WebSocket 连接成功')
      } catch (e) {
        console.log('WebSocket 连接失败，使用轮询:', e)
      }
    },
    handleWebSocketMessage(data) {
      if (data.type === 'newMessage' && data.sessionKey === this.sessionId) {
        // 如果是自己发送的消息（客户消息），跳过
        // 因为已经通过乐观更新添加了
        if (data.speakerType === 1 && data.customerName === this.customerName) {
          // Find temp message and replace its ID with real ID
          const tempIdx = this.chatMessages.findIndex(m =>
            m.content === data.content && m.id > 1000000000000
          )
          if (tempIdx !== -1) {
            this.chatMessages[tempIdx].id = data.id
            this.lastMessageId = Math.max(this.lastMessageId, data.id)
          }
          console.log('跳过自己发送的消息，已通过乐观更新添加')
          return
        }

        // 后端发送的是扁平格式，直接从 data 读取
        const exists = this.chatMessages.some(m => m.id === data.id)
        if (!exists) {
          const newMessage = {
            id: data.id,
            speakerType: data.speakerType,
            content: data.content,
            customerName: data.customerName,
            createdAt: data.createdAt
          }
          this.chatMessages.push(newMessage)
          this.lastMessageId = Math.max(this.lastMessageId, data.id)
          this.scrollToBottom()
          if (data.speakerType === 2) {
            this.playSound()
          }
          // 收到新消息就上报已读位置
          this.updateReadPosition(this.lastMessageId)
        }
      }
    },
    disconnectWebSocket() {
      if (this.wsUnsubscribe) {
        this.wsUnsubscribe()
        this.wsUnsubscribe = null
      }
    },
    // 发送心跳（轻量级）
    async sendHeartbeat() {
      try {
        await apiFetch('/api/chat/heartbeat', {
          method: 'POST',
          body: JSON.stringify({ username: this.customerName })
        })
      } catch (e) { /* ignore */ }
    },
    async updateOnlineStatus() {
      try {
        await apiFetch('/api/chat/online-status', {
          method: 'POST',
          body: JSON.stringify({ username: this.customerName, userType: 'customer', isOnline: true })
        })
      } catch (e) { console.error(e) }
    },
    setCustomerOffline() {
      const data = JSON.stringify({ username: this.customerName, userType: 'customer', isOnline: false })
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API_BASE_URL}/api/chat/online-status`, new Blob([data], { type: 'application/json' }))
      }
    },
    // 页面可见性变化处理
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // 页面变为可见：检查WS健康，重连，加载消息，恢复轮询
        if (!chatWebSocket.isConnected()) {
          this.connectWebSocket()
        }
        this.loadInitialMessages()
        this.checkNewMessages()
        this.startPolling()
      } else {
        // 页面隐藏：暂停所有轮询，节省服务器资源
        this.stopPolling()
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer
        if (container) container.scrollTop = container.scrollHeight
      })
    },
    isImageMessage(c) { return c && c.startsWith('[图片:') && c.endsWith(']') },
    getImageUrl(c) {
      if (!this.isImageMessage(c)) return ''
      const imagePath = c.slice(4, -1) // 去掉 [图片: 和 ]

      // 如果是完整URL（OSS云存储），直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath
      }

      // 否则是本地存储，拼接API路径
      return `${API_BASE_URL}/api/chat/image/${imagePath}`
    },
    isPaymentCard(c) { return c && /#payid\d+#/.test(c) },
    getPaymentOrderId(c) { const m = c && c.match(/#payid(\d+)#/); return m ? m[1] : '' },
    openPaymentPage(c) { const orderId = this.getPaymentOrderId(c); if (orderId) window.open(`${window.location.origin}/payment?order=${orderId}`, '_blank') },
    isLinkCardMessage(content) {
      return content && content.startsWith('[卡片:') && content.endsWith(']')
    },
    parseLinkCardMessage(content) {
      if (!this.isLinkCardMessage(content)) return { title: '', btnText: '查看详情', link: '' }
      var inner = content.slice(4, -1)
      var lastHttpIndex = inner.lastIndexOf(':http')
      if (lastHttpIndex === -1) {
        var parts = inner.split(':')
        if (parts.length >= 3) {
          var link = parts.pop()
          var btnText = parts.pop()
          return { title: parts.join(':'), btnText: btnText, link: link }
        }
        return { title: inner, btnText: '查看详情', link: '' }
      }
      var link = inner.substring(lastHttpIndex + 1)
      var beforeLink = inner.substring(0, lastHttpIndex)
      var lastColon = beforeLink.lastIndexOf(':')
      if (lastColon === -1) {
        return { title: beforeLink, btnText: '查看详情', link: link }
      }
      return {
        title: beforeLink.substring(0, lastColon),
        btnText: beforeLink.substring(lastColon + 1) || '查看详情',
        link: link
      }
    },
    openCardLink(link) { if (link) window.open(link, '_blank') },
    previewImage(c) {
      const url = this.getImageUrl(c)
      if (url) {
        this.previewImageUrl = url
        this.imagePreviewVisible = true
      }
    },
    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },
    playSound() {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)()
        const osc = ctx.createOscillator(), gain = ctx.createGain()
        osc.connect(gain); gain.connect(ctx.destination)
        osc.frequency.value = 800; osc.type = 'sine'
        gain.gain.setValueAtTime(0.3, ctx.currentTime)
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5)
        osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.5)
      } catch (e) { /* ignore */ }
    },
    async sendMessage() {
      const content = this.inputContent.trim()
      if (!content) return

      // 生成临时ID
      const tempId = Date.now()

      // 先添加到本地显示
      const tempMsg = {
        id: tempId,
        speakerType: 1,
        content: content,
        createdAt: new Date().toISOString()
      }
      this.chatMessages.push(tempMsg)
      this.inputContent = ''
      this.scrollToBottom()

      // 发送到后端，并更新临时消息ID
      await this.sendToBackend(content, tempId)
    },
    async sendToBackend(content, tempId) {
      this.updateOnlineStatus()
      let success = false
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const res = await apiFetch('/api/chat/send', {
            method: 'POST',
            body: JSON.stringify({
              sessionId: this.sessionId,
              agentAccount: this.agentAccount,
              speakerType: 1,
              content,
              customerName: this.customerName,
              platform: 'yl',
              isRead: false
            })
          })
          if (res.code === 0 && res.data?.messageId) {
            // 用真实ID替换临时ID
            if (tempId) {
              const msgIndex = this.chatMessages.findIndex(m => m.id === tempId)
              if (msgIndex !== -1) {
                this.chatMessages[msgIndex].id = res.data.messageId
              }
            }
            this.lastMessageId = Math.max(this.lastMessageId, res.data.messageId)
          }
          success = true
          break
        } catch (e) {
          console.error(`发送消息失败 (尝试 ${attempt + 1}/3):`, e)
          if (attempt < 2) await new Promise(r => setTimeout(r, 1000))
        }
      }
      if (success) {
        setTimeout(() => this.checkNewMessages(), 500)
      }
    },
    toggleToolbar() {
      this.showToolbar = !this.showToolbar
    },
    triggerImageUpload() {
      this.$refs.imageInput.click()
      this.showToolbar = false
    },
    async handleImageUpload(e) {
      const file = e.target.files[0]
      if (!file) return

      // 验证文件类型和大小
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif', 'image/tiff']
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(heic|heif|tiff|tif)$/i)) {
        alert('只支持 JPG、PNG、GIF、WebP、HEIC、HEIF、TIFF 格式的图片')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过 5MB')
        return
      }

      const formData = new FormData()
      formData.append('file', file)

      try {
        const response = await fetch(`${API_BASE_URL}/api/chat/upload-image`, {
          method: 'POST',
          body: formData
        })
        const result = await response.json()
        if (result.code === 0 && result.data?.imagePath) {
          const imageContent = `[图片:${result.data.imagePath}]`
          const tempId = Date.now()
          // 添加到本地显示
          this.chatMessages.push({
            id: tempId,
            speakerType: 1,
            content: imageContent,
            createdAt: new Date().toISOString()
          })
          this.scrollToBottom()
          await this.sendToBackend(imageContent, tempId)
        } else {
          alert(result.msg || '图片上传失败')
        }
      } catch (err) {
        console.error('上传图片失败:', err)
        alert('图片上传失败，请重试')
      }
      e.target.value = ''
    }
  }
}
</script>

<style scoped>
.yl-chat-page {
  height: 100vh;
  height: var(--app-height, 100dvh);
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.yl-error-container, .yl-loading-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.yl-error-icon { font-size: 64px; margin-bottom: 20px; }
.yl-error-title { font-size: 20px; font-weight: 600; color: #333; margin-bottom: 10px; }
.yl-error-message { font-size: 14px; color: #999; }
.yl-loading-spinner {
  width: 40px; height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #e8685d;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
.yl-loading-text { font-size: 14px; color: #666; }
.yl-chat-container { flex: 1; display: flex; flex-direction: column; background: #fff; overflow: hidden; }
.Nai-4lg2vHR7o-Long {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}
.Nai-jyPOXfXH1-Long {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.Nai-EzD-TlcDL-Long {
  height: 32px;
  object-fit: contain;
}
.yl-messages { flex: 1; overflow-y: auto; padding: 16px; background: #f8f8f8; }
.yl-message { display: flex; margin-bottom: 16px; align-items: flex-start; }
.yl-message-right { flex-direction: row-reverse; }
.Nai-LgT6OkF7v-Long {
  width: var(--avatarSize, 40px);
  height: var(--avatarSize, 40px);
  border-radius: var(--avatarBorderRadius, 0);
  overflow: hidden;
  flex-shrink: 0;
}
.Nai-LgT6OkF7v-Long img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.yl-avatar { width: 40px; height: 40px; border-radius: 50%; overflow: hidden; flex-shrink: 0; background: #fff; }
.yl-avatar img { width: 100%; height: 100%; object-fit: cover; }
.yl-bubble { max-width: 70%; padding: 10px 14px; border-radius: 8px; font-size: 15px; line-height: 1.5; word-break: break-word; margin: 0 10px; }
.yl-bubble-agent { background: #fff; color: #333; }
.yl-bubble-customer { background: #f0a099; color: #fff; }
.yl-msg-image { max-width: 200px; min-width: 100px; min-height: 100px; background-color: #f0f0f0; border-radius: 8px; cursor: pointer; }
.yl-input-area { background: #fff; padding: 12px 16px; border-top: 1px solid #eee; flex-shrink: 0; }
.yl-input-row { display: flex; align-items: center; gap: 12px; }
.yl-input-wrapper { flex: 1; background: #f5f5f5; border-radius: 20px; padding: 8px 16px; }
.yl-input { width: 100%; border: none; background: transparent; font-size: 15px; outline: none; }
.yl-input::placeholder { color: #999; }
.yl-add-btn { width: 32px; height: 32px; background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.yl-send-btn { width: 32px; height: 32px; background: #f0a099; border: none; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.yl-toolbar {
  display: flex;
  padding: 16px 20px;
  background: #f8f8f8;
  border-top: 1px solid #eee;
  margin-top: 10px;
  border-radius: 8px;
}
.yl-toolbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
}
.yl-toolbar-icon {
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}
.yl-toolbar-text {
  font-size: 12px;
  color: #666;
}

/* 支付卡片样式 */
.payment-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 12px;
  border-radius: 12px;
  gap: 12px;
  width: 100%;
  max-width: 240px;
  margin: 0 10px;
}

.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.payment-card-header img {
  height: 20px;
}

.payment-card-order {
  font-size: 13px;
  color: #666;
}

.payment-card-btn {
  background: #e62e2e;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.payment-card-btn:active {
  opacity: 0.8;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.image-preview-modal.active {
  display: flex;
}
.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* 链接卡片消息样式 */
.link-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.link-card-inner {
  padding: 0.75rem;
}
.link-card-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-card-btn {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  background: #007aff;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.link-card-btn:active {
  opacity: 0.8;
}

</style>
